import React from 'react'

export default class IconHome extends React.Component {

    render() {

        return (
            <svg id="icon-home" viewBox="0 0 32 32" fill="currentColor" className={this.props.className}>
                <title>home</title>
                <path
                    d="M16 1.5l-15 13h4v16h8v-10h6v10h8v-16h4l-15-13z"></path>
            </svg>
        )
    }
}
